export default "__VITE_ASSET__PS0utJku__"